export default __webpack_public_path__ + "9698f5d9a91da0dcac618ac98850c906.png";